import * as React from 'react'

import { Step as AuthModalStep } from 'main/components/common/AuthModal'
import { Button } from 'main/ui'
import SupportPhoneLink from '../SupportPhoneLink'
import { ItemContainer, StyledNativeLink } from './styles'

interface IProps {
  onRequestOpenAuthModal: (initialStep: AuthModalStep) => void
}

function AnonymousMenu(props: IProps) {
  const { onRequestOpenAuthModal } = props

  return (
    <ItemContainer>
      <StyledNativeLink href="/start">Start a Wonderschool</StyledNativeLink>
      <StyledNativeLink onClick={() => onRequestOpenAuthModal('login')} data-cy-hint="login-button">
        Log in
      </StyledNativeLink>
      <div>
        <Button
          kind="outline"
          onClick={() => onRequestOpenAuthModal('choose_role')}
          data-pendo="signUpCta"
        >
          Sign up
        </Button>
      </div>
      <SupportPhoneLink />
    </ItemContainer>
  )
}

export default React.memo(AnonymousMenu)
